import React, { useEffect, useState } from "react";
import "./styles/chatAdminScreen.css";
import "./styles/chatKeywordSearchStyles.css";
import TextField from "@mui/material/TextField";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import SideBar from "../../Common/SideBar";
import { useDispatch, useSelector } from "react-redux";
import { OvalLoader } from "../../Common/Loaders";

export default function ChatKeywordSearch() {
  const sidebar = useSelector((state) => state.sidebar);
  const [chatLoading, setChatLoading] = useState(false);
  const [noChatFound, setNoChatFound] = useState(false);

  const chatArray = [
    {
      id: 1,
      sender: "Merchant name",
      mssg: "this ahsd asdjasd bhbasdas dbasjdb ajsd jasbdhba shj djasbdhjabsdhj asbd asdbasbdjbasdbasd asbd asbdhasbdsd sdbjbs hdbsd bshdb hsbd hsb dhb shd sd hsdbhsd sbdhsbdh sdhbshdbhsdbh",
      timestamp: "12:45",
      chatType: "merchant",
    },
    {
      id: 3,
      sender: "Customer name",
      mssg: "this ahsd asdjasd bhbasdas dbasjdb ajsd jasbdhba ",
      timestamp: "12:45",
      chatType: "customer",
    },
    {
      id: 3,
      sender: "Admin",
      mssg: "this ahsd asdjasd bhbasdas dbasjdb ajsd jasbdhba jnasd jasb djabsdj ajsbdjasbdj asjdbjsad ",
      timestamp: "12:45",
      chatType: "admin",
    },
    {
      id: 4,
      sender: "Merchant name",
      mssg: "this ahsd asdjasd bhbasdas dbasjdb ajsd jasbdhba shj djasbdhjabsdhj asbd asdbasbdjbasdbasd asbd asbdhasbdsd sdbjbs hdbsd bshdb hsbd hsb dhb shd sd hsdbhsd sbdhsbdh sdhbshdbhsdbh",
      timestamp: "12:45",
      chatType: "merchant",
    },
    {
      id: 5,
      sender: "Customer name",
      mssg: "this ahsd asdjasd bhbasdas dbasjdb ajsd jasbdhba ",
      timestamp: "12:45",
      chatType: "customer",
    },
    {
      id: 6,
      sender: "Customer name",
      mssg: "this ahsd asdjasd bhbasdas dbasjdb ajsd jasbdhba ",
      timestamp: "12:45",
      chatType: "customer",
    },
    {
      id: 1,
      sender: "Merchant name",
      mssg: "this ahsd asdjasd bhbasdas dbasjdb ajsd jasbdhba shj djasbdhjabsdhj asbd asdbasbdjbasdbasd asbd asbdhasbdsd sdbjbs hdbsd bshdb hsbd hsb dhb shd sd hsdbhsd sbdhsbdh sdhbshdbhsdbh",
      timestamp: "12:45",
      chatType: "merchant",
    },
    {
      id: 3,
      sender: "Customer name",
      mssg: "this ahsd asdjasd bhbasdas dbasjdb ajsd jasbdhba ",
      timestamp: "12:45",
      chatType: "customer",
    },
    {
      id: 3,
      sender: "Admin",
      mssg: "this ahsd asdjasd bhbasdas dbasjdb ajsd jasbdhba jnasd jasb djabsdj ajsbdjasbdj asjdbjsad ",
      timestamp: "12:45",
      chatType: "admin",
    },
    {
      id: 4,
      sender: "Merchant name",
      mssg: "this ahsd asdjasd bhbasdas dbasjdb ajsd jasbdhba shj djasbdhjabsdhj asbd asdbasbdjbasdbasd asbd asbdhasbdsd sdbjbs hdbsd bshdb hsbd hsb dhb shd sd hsdbhsd sbdhsbdh sdhbshdbhsdbh",
      timestamp: "12:45",
      chatType: "merchant",
    },
    {
      id: 5,
      sender: "Customer name",
      mssg: "this ahsd asdjasd bhbasdas dbasjdb ajsd jasbdhba ",
      timestamp: "12:45",
      chatType: "customer",
    },
    {
      id: 6,
      sender: "Customer name",
      mssg: "this ahsd asdjasd bhbasdas dbasjdb ajsd jasbdhba ",
      timestamp: "12:45",
      chatType: "customer",
    },
  ];

  return (
    <div
      style={{ width: sidebar.expand ? "84vw" : "95vw" }}
      className="ScreenContainer"
    >
      <div className="upperSearchBarContainer">
        <div className="upperBarSearchBar">
          <div className="pageHeadingInnerContainer">
            <div className="pageHeading">Global Keyword Search</div>
          </div>
        </div>

        <div
          className="upperBarSearchBox upperBarSearchBoxProfile"
          style={{ border: "none" }}
        >
          <img src={require("../../../assets/profile.png")} alt="profile-pic" />
        </div>
        <div className="upperBarSearchBox upperBarSearchBoxNotification">
          <img
            src={require("../../../assets/exit.png")}
            alt="notification-bell"
          />
        </div>
      </div>
      <div className="chatOuterContainer">
        <div className="chatFirstContainer">
          <div className="chatFirstContainerHeader">Search Keyword</div>
          <div className="keywordSearchInputContainer">
            <TextField
              id="outlined-basic"
              label="Global Keyword Search"
              variant="outlined"
              sx={{ width: "90%" }}
            />
          </div>
          <div
            className="chatFirstContainerHeader"
            style={{ marginTop: "2vh", marginBottom: "1vh" }}
          >
            From Date
          </div>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <DatePicker label="Basic date picker" sx={{ width: "90%" }} />
            </DemoContainer>
          </LocalizationProvider>
          <div
            className="chatFirstContainerHeader"
            style={{ marginTop: "2vh", marginBottom: "1vh" }}
          >
            To Date
          </div>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <DatePicker label="Basic date picker" sx={{ width: "90%" }} />
            </DemoContainer>
          </LocalizationProvider>
          <div className="chatFetchButton">Search</div>
        </div>
        <div className="chatSecondContainer">
          {chatLoading ? (
            <div className="chatLoaderContainer">
              <OvalLoader />
            </div>
          ) : noChatFound ? (
            <div className="noChatFoundContainer">
              <div className="noChatsFoundLine">No Chats Found</div>
            </div>
          ) : (
            <div className="chatWindow">
              {chatArray.map((item) => (
                <div
                  className="chatBox"
                  // style={{
                  //   justifyContent:
                  //     item.chatType == "merchant" ? "flex-start" : "flex-end",
                  // }}
                >
                  <div className="chatMessage merchantChat" key={item.id}>
                    <div className="chatSender">{item.sender} > Reciever</div>
                    <div className="chatText">{item.mssg}</div>
                    <div className="chatTimeStamp">{item.timestamp}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
